//observatorio_react\src\pages\Noticias\index.js

import React from "react";
import { useAxios } from "../../hooks/useAxios";

import {
  DestaquePrincipal,
  SubDestaque,
  SessaoNoticiasMaisRecentes,
  BarraDePesquisaECategorias,
} from "../../components/page_components/NoticiasPage";
import { Header, Heading } from "./styles";

import LoadingScreen from "../../components/StatusScreens/MediumLoadingScreen";
import ErrorAlert from "../../components/Cards/ErrorAlertCard";
import Banner from "../../components/Banner";

export default function Noticias() {
  const [pesquisa, setPesquisa] = React.useState("");
  const [categoriaFiltro, setCategoriaFiltro] = React.useState("all");

  const uri = `/noticias/?emDestaque=3&&categorias=${categoriaFiltro}&&pesquisa=${pesquisa}`;
  const { loading, error, response } = useAxios({
    method: "GET",
    url: uri,
    headers: {
      accept: "*/*",
    },
  });

  return (
    <>
      <Banner
        titulo="Blog do Observatório"
        subtitulo={`Aqui você encontra notícias importantes sobre condições de 
        trabalho, saúde e segurança dos(as) trabalhadores(as) da saúde, além de 
        informações relacionadas a pesquisas e ações de enfrentamento à covid-19 
        a partir de estudos do nosso projeto e de publicações de outras fontes 
        confiáveis.`}
      />

      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          {error && (
            <div
              style={{
                height: "500px",
                padding: "0px 30px",
              }}
            >
              <ErrorAlert
                descricao={"Não foi possível carregar as notícias"}
                erroMsg={error}
              />
            </div>
          )}
          {response && (
            <div>
              <BarraDePesquisaECategorias
                categoria={categoriaFiltro}
                setPesquisa={setPesquisa}
                listaCategorias={response.dados.categorias}
                setCategoria={setCategoriaFiltro}
              />

              <Header>
                <Heading>Em destaque</Heading>
              </Header>

              {response.dados.noticias_destaque.length === 2 ? (
                <SubDestaque noticias={response.dados.noticias_destaque} />
              ) : (
                <DestaquePrincipal
                  noticias={response.dados.noticias_destaque[0]}
                />
              )}

              {response.dados.noticias_destaque.length > 2 ? (
                <SubDestaque
                  noticias={response.dados.noticias_destaque.slice(
                    1,
                    response.dados.noticias_destaque.length + 1
                  )}
                />
              ) : (
                <></>
              )}

              <SessaoNoticiasMaisRecentes
                noticias={response.dados.noticias_mais_recentes}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
}
